import React, { useState } from 'react';

import {
  Tr,
  Td,
  TdPrice,
  LabelWrapper,
  ButtonWrapper,
  SVGWrapper,
  CheckBoxWrapper,
  StyledCheckBox,
  CheckBoxLabel
} from './css';
import EditSVG from '../assets/svg/edit';
import CancelSVG from '../assets/svg/cancel';
import SaveSVG from '../assets/svg/save';
import {
  changeQuantity,
  deleteQuantity,
  saveQuantity
} from './saveSchemaToDB';

const QuantityField = ({
  serviceId,
  quantityData,
  fullyManagedAdminData,
  setFullyManagedAdminData,
  groupIndex,
  serviceIndex,
  setSavingData
}) => {
  let quantityLabel = '';
  let id = null;
  let isRequired = false;
  if (quantityData && quantityData.length > 0) {
    // Safely destructure if quantityData[0] exists
    [{ name: quantityLabel, id,isRequired }] = quantityData;
  }

  const [label, setLabel] = useState(quantityLabel);
  const [questionRequired, setQuestionRequired] = useState(isRequired);
  const [editMode, setEditMode] = useState(false);
  let quantityId = id;
  const handleCancel = () => {
    setLabel(quantityLabel);
    setEditMode(false);
  };

  const handleSave = async () => {
    const clonedAdminData = JSON.parse(JSON.stringify(fullyManagedAdminData));
    const productCatalogQuantityField = clonedAdminData[groupIndex].ServicesInGroup[
        serviceIndex
      ].productCatalogQuantities;
      if(productCatalogQuantityField.length === 0)
      {
          clonedAdminData[groupIndex].ServicesInGroup[
            serviceIndex
          ].productCatalogQuantities.push({
              id:null,
              name: '',
              isRequired:false,
              serviceId
          });
      }
   try
   {
    setSavingData(true);
    if (quantityId) {
      if (label.trim()) {

        await changeQuantity(quantityId, {
          name: label,
          isRequired: questionRequired
        });
        clonedAdminData[groupIndex].ServicesInGroup[
            serviceIndex
          ].productCatalogQuantities[0].isRequired = questionRequired;
          clonedAdminData[groupIndex].ServicesInGroup[
            serviceIndex
          ].productCatalogQuantities[0].name = label;
          clonedAdminData[groupIndex].ServicesInGroup[
            serviceIndex
          ].productCatalogQuantities[0].id = quantityId;
          clonedAdminData[groupIndex].ServicesInGroup[
            serviceIndex
          ].productCatalogQuantities[0].serviceId = serviceId;
      } else if(label.trim() === ""){
        await deleteQuantity(quantityId);
        clonedAdminData[groupIndex].ServicesInGroup[
          serviceIndex
        ].productCatalogQuantities[0] = [];
        setLabel('');
        setQuestionRequired(false);
      }
    } else if(label) {

      quantityId = await saveQuantity({
        name: label,
        serviceId,
        isRequired: questionRequired
      });
      clonedAdminData[groupIndex].ServicesInGroup[
        serviceIndex
      ].productCatalogQuantities[0].id = quantityId;
      clonedAdminData[groupIndex].ServicesInGroup[
        serviceIndex
      ].productCatalogQuantities[0].isRequired = questionRequired;
      clonedAdminData[groupIndex].ServicesInGroup[
        serviceIndex
      ].productCatalogQuantities[0].name = label;
      clonedAdminData[groupIndex].ServicesInGroup[
        serviceIndex
      ].productCatalogQuantities[0].serviceId = serviceId;
    }
    setFullyManagedAdminData(clonedAdminData);
    setEditMode(false);
   }
   catch{
    console.log("An error occurred while saving data");
        setSavingData(false);
    }
    finally{
        setSavingData(false);
    }

  };

  return (
    <Tr>
      <Td background="#f7f7f7">
        <LabelWrapper>
          {editMode ? (
            <>
              <input
                type="text"
                value={label}
                onChange={e => setLabel(e.target.value)}
              />
              <CheckBoxWrapper>
                <StyledCheckBox
                  id="checkbox-id"
                  checked={questionRequired}
                  onChange={e => setQuestionRequired(e.target.checked)}
                />
                <CheckBoxLabel htmlFor="checkbox-id">Required</CheckBoxLabel>
              </CheckBoxWrapper>
            </>
          ) : (
            <span>
              {label || '[Quantity label not added]'}
              {label && questionRequired ? '*' : ''}
            </span>
          )}
          <ButtonWrapper>
            {editMode ? (
              <>
                <SVGWrapper onClick={handleCancel}>
                  <CancelSVG />
                </SVGWrapper>
                <SVGWrapper onClick={handleSave}>
                  <SaveSVG />
                </SVGWrapper>
              </>
            ) : (
              <SVGWrapper onClick={() => setEditMode(!editMode)}>
                <EditSVG />
              </SVGWrapper>
            )}
          </ButtonWrapper>
        </LabelWrapper>
      </Td>
      <Td>
        <input type="text" value="" placeholder={label} disabled />
      </Td>
      <Td colSpan={2}></Td>
    </Tr>
  );
};

export default QuantityField;
